import { Video, VideoStatus } from '@monorepo/types';

/**
 * Get the display date for a video based on priority:
 * 1. Published videos: use publishAt
 * 2. Scheduled videos: use automaticPublishAt
 * 3. Fallback: use createdAt
 */
export const getVideoDisplayDate = (video: Video): Date => {
  // If video is published, use publishAt
  if (
    video.status === VideoStatus.Published &&
    video.socialPublishInfo?.publishAt
  ) {
    return new Date(video.socialPublishInfo.publishAt);
  }

  // If video has automatic publish date scheduled
  if (video.socialPublishInfo?.automaticPublishAt) {
    return new Date(video.socialPublishInfo.automaticPublishAt);
  }

  // Default to creation date
  return new Date(video.createdAt);
};
